{
  "mercury.focus-areas.heading": [
    {
      "type": 0,
      "value": "You're following "
    },
    {
      "type": 1,
      "value": "total"
    },
    {
      "type": 0,
      "value": " active focus areas, here's the breakdown."
    }
  ],
  "mercury.focus-areas.status.at-risk": [
    {
      "type": 0,
      "value": "At risk"
    }
  ],
  "mercury.focus-areas.status.completed": [
    {
      "type": 0,
      "value": "Completed ✨"
    }
  ],
  "mercury.focus-areas.status.off-track": [
    {
      "type": 0,
      "value": "Off track"
    }
  ],
  "mercury.focus-areas.status.on-track": [
    {
      "type": 0,
      "value": "On track"
    }
  ],
  "mercury.focus-areas.status.paused": [
    {
      "type": 0,
      "value": "Paused"
    }
  ],
  "mercury.focus-areas.status.pending": [
    {
      "type": 0,
      "value": "Pending"
    }
  ],
  "mercury.mercury-monthly-digest.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " - Total Focus Areas: "
    },
    {
      "type": 1,
      "value": "total"
    }
  ]
}